<template>
    <div>
        <vue-good-table
            :columns="columns"
            :rows="rows"
            :search-options="{
                enabled: true,
                skipDiacritics: true,
                placeholder: 'Cerca un cliente'
            }"
            :pagination-options="{
                enabled: true,
                mode: 'pages',
                perPage: 50
            }"
            theme="polar-bear">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'paid_action'">
                    <span v-if="props.row.is_paid == 1">✅</span>
                </span>
                <span v-if="props.column.field == 'action'" class="flex justify-between">
                    <span style="font-weight: bold;">
                        <a class="p-2 mx-2 text-white bg-blue-600 rounded-md hover:bg-blue-900 action-tooltip" :href="`/admin_audiobooks/edit/${props.row.id}`">
                            <svg class="w-4 h-4" width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.4445 19.6875H20.9445M14.4443 5.68747L5.44587 14.6859C4.78722 15.3446 4.26719 16.1441 4.10888 17.062C3.94903 17.9888 3.89583 19.139 4.44432 19.6875C4.99281 20.236 6.14299 20.1828 7.0698 20.0229C7.98772 19.8646 8.78722 19.3446 9.44587 18.6859L18.4443 9.68747M14.4443 5.68747C14.4443 5.68747 17.4443 2.68747 19.4443 4.68747C21.4443 6.68747 18.4443 9.68747 18.4443 9.68747M14.4443 5.68747L18.4443 9.68747" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span class="tiptext">scheda modifica</span>
                        </a>                
                    </span> 
                    <span style="font-weight: bold;">
                        <a class="p-2 mx-2 text-white bg-green-600 rounded-md hover:bg-green-900 action-tooltip" :href="`/admin_audiobooks/show/${props.row.id}`">
                            <svg viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                            <span class="tiptext">vedi scheda</span>
                        </a>                
                    </span> 
                </span>
                <span v-else>
                    {{props.formattedRow[props.column.field]}}
                </span>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css';
import { VueGoodTable } from 'vue-good-table';
import { Form } from 'vform';

export default {
    props: ['rows'],
    components : {VueGoodTable},
    name: 'table-students',
    data(){
        return {
            form: new Form({
                id:''
            }),
            columns: [
                {
                    label: 'Title',
                    field: 'title',
                    sortable: true
                },
                {
                    label: 'Description',
                    field: 'description',
                    sortable: true
                },
                {
                    label: 'Author',
                    field: 'author',
                    sortable: true
                },
                {
                    label: 'is_paid',
                    field: 'paid_action',
                    sortable: true
                },
                {
                    label: 'Azioni',
                    field: 'action',
                    sortable: false
                },
            ],
        };
    },
    methods: {
        client(rowObj) {
            return (rowObj.name)+(' ')+(rowObj.last_name);
        },
    },
};
</script>


<style>

.action-tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.action-tooltip  .tiptext {
  visibility: hidden;
  width: 120px;
  background-color: rgba( 0,0,0, 0.7 );
  color: #fff;
  font-size: 11px;
  text-align: center;
  padding: 4px 0;
  border-radius: 6px;
  position: absolute;
  width: 80px;
  bottom: 105%;
  left: 50%;
  margin-left: -40px;
  z-index: 1;
  }

.action-tooltip:hover .tiptext {
  visibility: visible;
}

</style>